import * as React from "react";
import {
  Text,
  View,
  StyleSheet,
  Image,
  TouchableWithoutFeedback,
  TouchableOpacity,
  Platform,
  Linking
} from "react-native";

import { useNavigation } from "@react-navigation/native";
import GlobalStyles from "../../components/GlobalStyles";
import GenericButton from "../../components/GenericButton.js"

export default function SpendingInsightsAboutPendingScreen() {
  const navigation = useNavigation();
  const sparkle = require("../../assets/res/sparkle.png");
  return (
    <View style={GlobalStyles.containerMB}>
      <View style={styles.modalContainerF}>
        <View style={styles.modalContainer}>
          <View>
            <View style={GlobalStyles.headerTextP}>
              <View style={GlobalStyles.headingStyle}>
                <View style={styles.PopupHeader}>
                  <Text style={styles.textStyleHeader}>
                  Within two days your purchase will appear as Pending. Within 1-4 weeks eligible purchases will be approved and your pending amount will move to your Balance.
                  </Text>
                  <Text style={styles.textStyleHeader}>
                  This pending period is to cater for any returns that may occur.
                  </Text>
                    <Text style={styles.textStyleHeader}>
                    Find out more about your Aura rewards in our&nbsp;
                      <Text style={[styles.textStyleHeaderFAQ, { textDecorationLine: 'underline' }]}
                            onPress={() => {
                        Platform.OS !== "web"
                          ? Linking.openURL("https://aura.club/faqs")
                          : window.open("https://aura.club/faqs", "_blank");
                      }}>
                      FAQ's.
                      </Text>
                    </Text>
                </View>
                <View style={styles.modalContainerSD}>
                  <GenericButton
                    buttonText='OK'
                    onPress={() => navigation.goBack()}
                    buttonWidth={150}
                    buttonTextSize={12}
                    buttonColor="#FFFFFF"
                  />
                </View>
              </View>
            </View>
          </View>
        </View>
        <View>
          <Image style={styles.sparkle} source={sparkle} />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  PopupHeader: {
    paddingBottom: 30,
    paddingRight: 20,
  },
  modalContainer: {
    height: 450,
    backgroundColor: "#FFC72C",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 70,
    borderTopLeftRadius: 70,
    borderTopRightRadius: 70,
    marginLeft: 15,
    marginRight: 15,
    paddingTop: 55,
  },

  modalContainerSD: {
    paddingRight: 40,
  },


  modalContainerF: {
    marginTop: 130,
    paddingTop: 55,
    marginLeft: 15,
    marginRight: 15,
  },
  SubmitButtonStyle: {
    paddingTop: 20,
    paddingBottom: 25,
    borderRadius: 50,
    backgroundColor: "#FFFFFF",
    //marginTop: 20,
    marginLeft: -15,
    paddingLeft: 20,
    paddingRight: 20,
    height: 60,
    width: 120,
    alignItems: "center",
  },
  textStyleHeader: {
    color: "#333333",
    textAlign: "left",
    fontFamily: "montserrat-medium",
    fontSize: 14,
    marginLeft: -15,
    paddingBottom: 20,
  },
  textStyleHeaderFAQ: {
    color: "#333333",
    textAlign: "left",
    fontFamily: "montserrat-medium",
    fontSize: 14,
    paddingBottom: 20,
  },
  TextStyle: {
    color: "#000000",
    textAlign: "center",
    fontFamily: "montserrat-medium",
    fontSize: 14,
  },
  sparkle: {
    position: "absolute",
    top: -465,
    right: -5,
    width: 40,
    height: 40,
  },
});
